import {
  CircleCheck,
  CircleInfo,
  CircleXmark,
  MoneyCheckPen,
} from '@unified-checkout/design-system/icons/index';
import { TRANSFERS_STATUS } from '..';

export const BREAK_DOWN_VIEWS = {
  COMPACT: 'compact',
  DETAILED: 'detailed',
};

export const COMPACT_VIEW_OPTIONS = {
  NET_AMOUNT: 'netAmount',
  FEES: 'fees',
  ADJUSTMENTS: 'adjustments',
};

export const PROGRESS_BANNER_ICON = {
  [TRANSFERS_STATUS.SETTLED]: {
    icon: CircleCheck,
    type: 'success',
  },
  [TRANSFERS_STATUS.RETURNED_BY_BANK]: {
    icon: CircleXmark,
    type: 'error',
  },
  [TRANSFERS_STATUS.REJECT_INSTANT]: {
    icon: CircleXmark,
    type: 'error',
  },
  [TRANSFERS_STATUS.FAILED]: {
    icon: CircleXmark,
    type: 'error',
  },
  [TRANSFERS_STATUS.INITIATED]: {
    icon: CircleInfo,
    type: 'brand',
  },
  [TRANSFERS_STATUS.IN_REVIEW]: {
    icon: MoneyCheckPen,
    type: 'brand',
  },
} as const;

export const REPORT_FILE_TYPES = {
  PDF: 'pdf',
  CSV: 'csv',
} as const;

export const SUMMARY_CARD_IDS_TYPES = {
  TRANSFER_ID: 'transfer_id',
  SETTLEMENT_ID: 'settlement_id',
} as const;

export const TRANSFER_ACTIONS = {
  DOWNLOAD_PROOF: 'download_proof',
  DOWNLOAD_TRANSACTIONS_CSV: 'download_transactions_csv',
  DOWNLOAD_TRANSACTIONS_PDF: 'download_transactions_pdf',
} as const;

export const TRUNCATED_SUMMARY_LENGTH = 20;

export const INSTANT_SETTLEMENT = 'instant';
